import { render, staticRenderFns } from "./NoStamp.vue?vue&type=template&id=6615d410&scoped=true&"
import script from "./NoStamp.vue?vue&type=script&lang=js&"
export * from "./NoStamp.vue?vue&type=script&lang=js&"
import style0 from "./NoStamp.vue?vue&type=style&index=0&id=6615d410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615d410",
  null
  
)

export default component.exports